import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './App.css';

const basename = "/";

if ("serviceWorker" in navigator) {
navigator.serviceWorker.register("/service-worker-v10.js").then(reg => {
  console.log("SW registered:", reg);

  // Force update check
  reg.update();
});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename={basename}>
    <App />
  </BrowserRouter>
);
